// removed by extract-text-webpack-plugin
module.exports = {"root":"menu-link--root--3fM-xSxZ organization-home--root--29mpR9MJ","filters":"menu-link--filters--thm4M6f7","toggle":"menu-link--toggle--3HIXU1Aa","container-link":"menu-link--container-link--S09D7Z-X","containerLink":"menu-link--container-link--S09D7Z-X","item-link":"menu-link--item-link--d2N7_hOo","itemLink":"menu-link--item-link--d2N7_hOo","subitem-link":"menu-link--subitem-link--3ABKONee","subitemLink":"menu-link--subitem-link--3ABKONee","label":"menu-link--label--q9a5EhtD","divider":"menu-link--divider--1Swx0CxR","marker":"menu-link--marker--2DHF-J1s"};


//////////////////
// WEBPACK FOOTER
// ./components/header/menu-link/styles.css
// module id = ./components/header/menu-link/styles.css
// module chunks = 0